import React from 'react';
import PropTypes from 'prop-types';
import { Bert } from 'meteor/themeteorchef:bert';
import {
  Box,
  FormControl,
  IconButton,
  InputAdornment,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography
} from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import SaveIcon from '@mui/icons-material/Save';
import PlagiarismOutlinedIcon from '@mui/icons-material/PlagiarismOutlined';

const UploadFileISLComponent = ({ ipsOfIsl }) => {
  const [openModal, setOpenModal] = React.useState(false);
  const [importFile, setImportFile] = React.useState(null);
  const fileInputRef = React.useRef(null);
  const [importName, setImportName] = React.useState('');
  const [urlSelected, setUrlSelected] = React.useState(ipsOfIsl.links[0]);

  const addPathToUrl = (urlProp, type) => {
    let url = urlProp;
    const pathISL = 'MG/isl/exec_isl';
    const pathAirflow = 'MG/airflow/exec_airflow';
    if (!url.endsWith('/')) {
      url += '/';
    }
    if (type === 'Airflow') {
      return url + pathAirflow;
    }
    if (type === 'ISL') {
      return url + pathISL;
    }
    return '';
  };

  const loadFileToBack = async () => {
    if (!importFile) {
      Bert.alert('Selecciona un archivo primero', 'danger');
      setImportFile('');
      return;
    }

    const extension = importFile.name.substring(importFile.name.lastIndexOf('.'));
    const updatedFile = new File([importFile], `${importName}${extension}`, {
      type: importFile.type,
      lastModified: importFile.lastModified
    });

    const formData = new FormData();
    formData.append('file', updatedFile);
    formData.append('disc', 'data3');

    try {
      const response = await fetch('https://sd1.d3.ipsilum.com/upload', {
        method: 'POST',
        body: formData,
        mode: 'cors',
        credentials: 'omit',
        referrerPolicy: 'no-referrer'
      });

      if (!response.ok) {
        throw new Error('Error uploading file');
      }

      const respuesta = await response.json();

      const secondResponse = await fetch(addPathToUrl(urlSelected.url, urlSelected.type), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          disk: 'data3',
          write_data_available: {
            data_value: respuesta.data.link,
            user: 'Superusuario',
            data_name: 'Entrada de prueba 2',
            is_basic: 'True',
            show_deleted: 'False',
            functions_affected: ''
          }
        }),
        mode: 'cors',
        credentials: 'omit',
        referrerPolicy: 'no-referrer'
      });

      if (!secondResponse.ok) {
        throw new Error('Error in the second API call');
      }

      const secondRespuesta = await secondResponse.json();
      if (secondRespuesta === true) {
        Bert.alert('Archivo subido correctamente', 'success');
      }
    } catch (error) {
      console.error('Error:', error);
      Bert.alert('Error al subir el archivo', 'danger');
    }
  };

  return (
    <>
      <IconButton
        onClick={() => setOpenModal(true)}
        style={{
          color: 'white'
        }}
      >
        <UploadFileIcon />
      </IconButton>
      <Modal
        open={openModal}
        onClose={() => {
          setImportName('');
          setOpenModal(false);
        }}
      >
        <Box
          component="form"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: 2,
            backgroundColor: 'white',
            position: 'absolute',
            top: '2.5vh',
            left: '2.5vw',
            width: '95%',
            height: '95%'
          }}
          noValidate
          autoComplete="off"
        >
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              mb: 5,
              padding: '16px',
              backgroundColor: '#f5f5f5',
              height: '5%'
            }}
          >
            <Typography variant="h6">Upload File to Server</Typography>
          </Box>
          <Box
            sx={{
              width: '50%',
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              alignItems: 'center',
              height: '95%'
            }}
          >
            <FormControl variant="standard" size="small" fullWidth>
              <Select
                labelId="select-label"
                fullWidth
                value={urlSelected.url}
                onChange={event => {
                  const serverSelectedSearch = ipsOfIsl.links.find(
                    element => element.url === event.target.value
                  );
                  setUrlSelected(serverSelectedSearch);
                }}
                sx={{ width: '50%', color: 'black' }}
              >
                {ipsOfIsl.links.map(item => (
                  <MenuItem key={item.url} value={item.url}>
                    {item.url}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <TextField
              fullWidth
              label="Nombre del archivo"
              size="small"
              value={importName}
              onChange={event => setImportName(event.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      variant="contained"
                      aria-label="upload"
                      component="label"
                      onClick={() => fileInputRef.current.click()}
                      sx={{ color: '#2A3F90' }}
                    >
                      <PlagiarismOutlinedIcon />
                    </IconButton>
                    <IconButton
                      variant="contained"
                      aria-label="upload"
                      component="label"
                      onClick={() => loadFileToBack()}
                      sx={{ color: '#2A3F90' }}
                    >
                      <SaveIcon />
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />

            <input
              ref={fileInputRef}
              type="file"
              style={{ display: 'none' }}
              onChange={event => {
                setImportFile(event.target.files[0]);
                const nameWithoutExtension = event.target.files[0].name.substring(
                  0,
                  event.target.files[0].name.lastIndexOf('.')
                );
                setImportName(nameWithoutExtension);
              }}
            />
          </Box>
        </Box>
      </Modal>
    </>
  );
};

UploadFileISLComponent.propTypes = {
  ipsOfIsl: PropTypes.object.isRequired
};

export default UploadFileISLComponent;
